// extracted by mini-css-extract-plugin
module.exports = {"familiesBanner":"FamiliesBanner_familiesBanner__EF5AK","minFamiliesBanner":"FamiliesBanner_minFamiliesBanner__WxBVv","maxFamiliesBanner":"FamiliesBanner_maxFamiliesBanner__WsNbj"};